<template>
    <div>
        <PurchaseMaster addNew="/purchase/purchase-order/" type="PO"></PurchaseMaster>
    </div>
</template>
<script>
import { mapState } from "vuex";
import PurchaseMaster from './master.vue'

export default {
    components: { PurchaseMaster },
    computed:{
    ...mapState({
        language_terms: state => state.languages.language_terms,
      }),
    }
}
</script>
